module.exports = "/_next/static/images/stormRestoration-4aab1205a8a8366e926900e5aa335641.webp";